import {
  getDatabaseConnectionDetails,
  getDatabaseConnections,
  addDatabaseConnection,
  deleteDatabaseConnection,
  updateDatabaseConnection,
} from "~/lib/network/database-connection";

export type Connection = {
  _id: string;
  name: string;
  connection_type: string;
  attachments: any[];
  description?: string;
  sync_status?: string;
  created_at: string;
  updated_at: string;
};

export type DatabaseState = {
  selectedDatabase: string;  // Deprecated: kept for backward compatibility
  connectionsList: Connection[];
  connectionDetails: any;
  setSelectedDatabase: (database: string) => void;  // Deprecated
  resetDatabase: () => void;
  reset: () => void;
};

const defaultState: DatabaseState = {
  selectedDatabase: "",
  connectionsList: [],
  connectionDetails: null,
  setSelectedDatabase: () => {},
  resetDatabase: () => {},
  reset: () => {},
};

export const createDatabaseSlice = (set: any, get: any, storeApi: any) => {
  return {
    ...defaultState,
    addConnection: async (newConnection: any) => {
      const response = await addDatabaseConnection(newConnection);
      set((state: DatabaseState) => ({
        connectionsList: [...state.connectionsList, response],
      }));
    },
    deleteConnection: async (connectionId: string) => {
      const response = await deleteDatabaseConnection(connectionId);
      set((state: DatabaseState) => ({
        connectionsList: state.connectionsList.filter(
          (connection) => connection._id !== connectionId
        ),
      }));
    },
    updateConnection: async (connectionId: string, data: any) => {
      const response = await updateDatabaseConnection(connectionId, data);
      set((state: DatabaseState) => ({
        connectionsList: state.connectionsList.map((connection) =>
          connection._id === connectionId ? response : connection
        ),
      }));
    },
    setSelectedDatabase: (database: string) =>
      set({ selectedDatabase: database }),
    getConnectionsList: async () => {
      const response = await getDatabaseConnections();
      set({ connectionsList: response });
    },
    getConnectionDetails: async (connection: Connection) => {
      const response = await getDatabaseConnectionDetails(connection._id);
      set({
        connectionDetails: {
          ...connection,
          ...response,
          // Ensure fresh data from DB takes precedence
          attachments: response.attachments,
        },
      });
    },
    reset: () => set(defaultState),
  };
};
